import React from 'react'

const ReworkReasonModalUI = ({
  title,
  remarks,
  onRemarksChange,
  onSubmitClick,
  onCancelClick,
  submitting
}) => {
  return (
    <div className="modal-backdrop" style={backdropStyle}>
      <div className="modal-content" style={modalStyle}>
        <h3 style={{ marginTop: 0 }}>{title || 'Rework Reason'}</h3>

        <p style={{ marginBottom: '15px', color: '#6c757d' }}>
          Please provide a reason for sending this checklist back for rework (optional):
        </p>

        <textarea
          value={remarks}
          onChange={(e) => onRemarksChange(e.target.value)}
          placeholder="Enter rework reason here (optional)..."
          style={textareaStyle}
          rows={5}
          disabled={submitting}
        />

        <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
          <button
            onClick={onSubmitClick}
            disabled={submitting}
            style={{ ...buttonStyle, ...submitButtonStyle }}
          >
            {submitting ? 'Sending...' : 'Send for Rework'}
          </button>
          <button
            onClick={onCancelClick}
            disabled={submitting}
            style={{ ...buttonStyle, ...cancelButtonStyle }}
          >
            Close this tab
          </button>
        </div>
      </div>
    </div>
  )
}

const backdropStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1001
}

const modalStyle = {
  backgroundColor: 'white',
  borderRadius: '8px',
  padding: '24px',
  minWidth: '450px',
  maxWidth: '600px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
}

const textareaStyle = {
  width: '100%',
  padding: '12px',
  fontSize: '14px',
  border: '1px solid #ced4da',
  borderRadius: '4px',
  fontFamily: 'inherit',
  resize: 'vertical',
  outline: 'none',
  transition: 'border-color 0.2s',
  boxSizing: 'border-box'
}

const buttonStyle = {
  padding: '10px 20px',
  fontSize: '14px',
  fontWeight: '500',
  cursor: 'pointer',
  border: 'none',
  borderRadius: '4px',
  transition: 'all 0.2s',
  flex: 1
}

const submitButtonStyle = {
  backgroundColor: '#ffc107',
  color: '#000'
}

const cancelButtonStyle = {
  backgroundColor: '#6c757d',
  color: '#fff'
}

export default ReworkReasonModalUI